import { useCallback, useEffect, useState } from "react";
import api from "../api";
import { formaterDate } from "../format";

/**
 * Journal d'audit — le meme composant des deux cotes.
 *
 * Cote CLIENT (`/journal`) : l'administrateur voit qui a touche a ses donnees,
 * l'editeur compris. C'est tout l'interet du dispositif -- une trace que seul
 * l'observateur peut consulter ne rassure personne.
 *
 * Cote PLATEFORME (`/plateforme/clients/{id}/journal`) : la meme chose, vue de
 * l'editeur. Deliberement identique : ce que vous montrez au client est
 * exactement ce que vous voyez.
 */

/** Traduction des methodes techniques en langage lisible. */
const LIBELLES = {
  CONNEXION: "Connexion",
  CONSULTATION: "Consultation par le prestataire",
  EXPORT: "Export des données",
  SUPPRESSION: "Suppression",
  POST: "Création",
  PUT: "Modification",
  PATCH: "Modification",
  DELETE: "Suppression",
  GET: "Consultation",
};

/** Ce que l'entree raconte, en une phrase. */
function decrire(entree) {
  const quoi = LIBELLES[entree.methode] || entree.methode;
  const refuse = entree.code_reponse && entree.code_reponse >= 400;
  return { quoi, refuse };
}

function horodatage(iso) {
  if (!iso) return "—";
  const heure = iso.slice(11, 19);
  return `${formaterDate(iso.slice(0, 10))} à ${heure}`;
}

export default function Journal({ url, titre, sousTitre, onFermer }) {
  const [entrees, setEntrees] = useState(null);
  const [erreur, setErreur] = useState("");

  const charger = useCallback(() => {
    api
      .get(url)
      .then(({ data }) => setEntrees(data))
      .catch(() => setErreur("Impossible de charger le journal."));
  }, [url]);

  useEffect(charger, [charger]);

  return (
    <div className="modal-overlay" onClick={onFermer}>
      <div
        className="modal-carte modal-large"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="modal-titre">{titre}</h3>
        {sousTitre && <p className="modal-sous-titre">{sousTitre}</p>}

        {erreur && <p className="erreur">{erreur}</p>}
        {!entrees && !erreur && <p className="vide">Chargement…</p>}
        {entrees && entrees.length === 0 && (
          <p className="vide">Aucune activité enregistrée pour l’instant.</p>
        )}

        {entrees && entrees.length > 0 && (
          <div className="journal-liste">
            {entrees.map((e) => {
              const { quoi, refuse } = decrire(e);
              return (
                // Deux colonnes seulement : quand / quoi. Le chemin technique
                // passe SOUS l'action plutot que dans une troisieme colonne --
                // il est de longueur imprevisible, et le mettre en colonne le
                // faisait deborder ou chevaucher le texte des qu'une modale
                // etait un peu etroite.
                <div key={e.id} className="journal-ligne">
                  <div className="journal-quand">{horodatage(e.date)}</div>
                  <div className="journal-quoi">
                    <div>
                      <strong>{quoi}</strong>
                      {refuse && <span className="journal-refuse">refusé</span>}
                    </div>
                    <div className="sous-info">
                      {e.email || "—"}
                      {e.detail ? ` · ${e.detail}` : ""}
                    </div>
                    <div className="journal-chemin">{e.chemin}</div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        <p className="sous-info" style={{ marginTop: 16 }}>
          Le contenu des requêtes n’est jamais enregistré — ni mots de passe,
          ni données saisies. Seulement qui, quoi, quand, et le résultat.
        </p>

        <div className="modal-actions">
          <button className="btn" onClick={onFermer}>
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
}
